import { useState } from "react";
import Layout from "./Layout.js";
import Loader from "./Loader.js";
import OperationalRecommandations from "./OperationalRecommandations.js";
import FeedbackIntelligence from "./FeedbackIntelligence.js";
import AICrowdDynamics from "./AICrowdDynamics.js";
import AIExecutiveSummary from "./AIExecutiveSummary.js";

export default function Reports() {
  const [isLoading, setIsLoading] = useState(false);
  const [activeTab, setActiveTab] = useState("report1");

  const renderTabContent = () => {
    switch (activeTab) {
      case "report1":
        return <OperationalRecommandations/>;
      case "report2":
        return <FeedbackIntelligence />;
      case "report3":
        return <AICrowdDynamics />;
      case "report4":
        return <AIExecutiveSummary />;
      default:
        return null;
    }
  };

  return (
    <>
      {isLoading && <Loader />}
      <Layout>
        <div className="page">
          {/* Tabs */}
          <div className="tabs">
            <button
              className={activeTab === "report1" ? "active" : ""}
              onClick={() => setActiveTab("report1")}
            >
              Operational Recommandations
            </button>
            <button
              className={activeTab === "report2" ? "active" : ""}
              onClick={() => setActiveTab("report2")}
            >
              Feedback Intelligence
            </button>
            <button
              className={activeTab === "report3" ? "active" : ""}
              onClick={() => setActiveTab("report3")}
            >
              AI Crowd Dynamics
            </button>
            <button
              className={activeTab === "report4" ? "active" : ""}
              onClick={() => setActiveTab("report4")}
            >
              AI Executive Summary
            </button>
          </div>

          {/* Tab content */}
          <div className="tab-content">{renderTabContent()}</div>
        </div>
      </Layout>
    </>
  );
}
